<template>
    <div class="caution">
        <img src="../../assets/img/caution.png" alt="caution">
    </div>
</template>

<script>
    export default {
        name: "Caution",
        methods: {
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    div.caution{
        position: fixed;
        left:0;
        top:0;
        height: 100vh;
        width: 100vw;
        background-color: rgba(255,255,255,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        img{
            width: 60vw;
        }
    }

</style>
